import { render, staticRenderFns } from "./CustomerListTable.vue?vue&type=template&id=94fbd9cc&scoped=true&"
import script from "./CustomerListTable.vue?vue&type=script&lang=js&"
export * from "./CustomerListTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListTable.vue?vue&type=style&index=0&id=94fbd9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fbd9cc",
  null
  
)

export default component.exports